(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-bundle-colour-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-bundle-picker')) {
customElements.define('aw-bundle-picker', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
this.section = this.closest('[data-aw-native-product]');
this.native = this.section?.querySelector('[data-aw-native-variant]');
this.axes = [...this.querySelectorAll('[data-aw-bundle-axis]')];
try { this.variants = JSON.parse(this.section.querySelector('[data-aw-native-variants]').textContent); } catch { return; }
if (!this.native) return;
this.native.dataset.awBundleNative = '';
const label = this.section.querySelector('label[for="' + this.native.id + '"]');
if (label) label.hidden = true;
this.addEventListener('change', event => { if (event.target.matches('[data-aw-colour]')) this.sync(true); });
this.native.addEventListener('change', () => this.syncFromNative());
this.variants.forEach(item => {
const groups = new Map();
item.options?.forEach((value, index) => {
const input = [...this.axes[index].querySelectorAll('[data-aw-colour]')].find(choice => choice.value === value);
if (!input) return;
const key = input.dataset.sourceId;
const group = groups.get(key) || { stock: Number(input.dataset.stock), quantity: 0 };
group.quantity += 1;
groups.set(key, group);
});
const componentStock = groups.size ? Math.min(...[...groups.values()].map(group => Math.floor(group.stock / group.quantity))) : 0;
item.inventory = this.dataset.componentLinked === 'true' ? Math.max(0, componentStock) : Math.max(0, Math.min(Number(item.inventory) || 0, componentStock));
});
this.section.querySelector('[data-aw-native-variants]').textContent = JSON.stringify(this.variants);
this.sync(false);
}
selections() { return this.axes.map(axis => axis.querySelector('[data-aw-colour]:checked')?.value); }
syncFromNative() {
const variant = this.variants.find(item => String(item.id) === this.native.value);
if (!variant?.options) return;
this.axes.forEach((axis, index) => { axis.querySelectorAll('[data-aw-colour]').forEach(input => { input.checked = input.value === variant.options[index]; }); });
this.sync(false);
}
sync(notify) {
const values = this.selections();
const variant = this.variants.find(item => item.options?.every((value, index) => value === values[index]));
this.axes.forEach((axis, index) => {
const picked = axis.querySelector('[data-aw-colour]:checked');
axis.querySelectorAll('[data-aw-colour]').forEach(input => { input.disabled = !this.variants.some(item => item.inventory > 0 && item.options?.[index] === input.value && item.options.every((value, other) => other === index || value === values[other])); });
axis.querySelector('[data-aw-chosen-colour]').textContent = picked?.value || '';
const image = axis.querySelector('.aw-bundle-selected-photo img');
if (image && picked?.dataset.photo) { image.removeAttribute('srcset'); image.src = picked.dataset.photo; image.alt = picked.dataset.photoAlt; }
});
this.querySelector('[data-aw-bundle-summary]').textContent = this.dataset.summaryLabel + ' ' + this.axes.map((axis, index) => axis.querySelector('legend').childNodes[0].textContent.split(':')[0] + ': ' + values[index]).join(' + ');
const error = this.querySelector('[data-aw-bundle-error]');
error.hidden = Boolean(variant?.inventory > 0);
error.textContent = error.hidden ? '' : this.dataset.unavailable;
if (notify && variant) { this.native.value = String(variant.id); this.native.dispatchEvent(new Event('change', { bubbles: true })); }
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aw-downloads-draft"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aw-downloads')){
customElements.define('aw-downloads',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.search=this.querySelector('[data-awdl-search]');this.filters=[...this.querySelectorAll('[data-awdl-filter]')];this.cards=[...this.querySelectorAll('[data-awdl-card]')];this.groups=[...this.querySelectorAll('[data-awdl-group]')];this.category='All';
this.search.addEventListener('input',()=>this.filter());
this.filters.forEach(button=>button.addEventListener('click',()=>{this.category=button.dataset.awdlFilter;this.filters.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.filter();}));
this.querySelector('[data-awdl-reset]').addEventListener('click',()=>{this.search.value='';this.category='All';this.filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.awdlFilter==='All')));this.filter();this.search.focus({preventScroll:true});});
}
normalise(value){return value.toLowerCase().replace(/[^a-z0-9]/g,'');}
filter(){
const term=this.normalise(this.search.value);let visible=0;
this.cards.forEach(card=>{card.hidden=!((this.category==='All'||card.dataset.category===this.category)&&this.normalise(card.dataset.search).includes(term));if(!card.hidden)visible++;});
this.groups.forEach(group=>{const count=[...group.querySelectorAll('[data-awdl-card]')].filter(card=>!card.hidden).length;group.hidden=count===0;group.querySelector('.awdl-category-heading>span').textContent=count+' '+(count===1?'model':'models');});
this.querySelector('[data-awdl-count]').textContent=visible+' '+(visible===1?'manual':'manuals')+' '+(term||this.category!=='All'?'found':'available');
this.querySelector('[data-awdl-empty]').hidden=visible!==0;
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aw-launch-zoom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-launch-zoom')) {
customElements.define('aw-launch-zoom', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready=true;
const section=this.closest('[data-aw-native-product]');
const triggers=[...section.querySelectorAll('[data-aw-open-zoom]')];
let lastTrigger=triggers[0];
const dialog=this.querySelector('dialog');
const image=this.querySelector('img');
const toggle=this.querySelector('[data-aw-zoom-size]');
let previousOverflow='';
triggers.forEach(trigger=>trigger.addEventListener('click',()=>{
lastTrigger=trigger;
if(dialog.open)return;
const source=section.querySelector('.main-product-image img');
if(!source) return;
const url=new URL(source.src,location.href);
url.searchParams.set('width','2160');
image.src=url.href;
image.alt=source.alt;
dialog.classList.add('is-zoomed');
toggle.setAttribute('aria-pressed','true');
toggle.textContent=toggle.dataset.out;
previousOverflow=document.documentElement.style.overflow;
document.documentElement.style.overflow='hidden';
dialog.showModal();
this.querySelector('.aw-launch-dialog-scroll').scrollTo(0,0);
}));
this.querySelector('[data-aw-close-zoom]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;lastTrigger?.focus();});
toggle.addEventListener('click',()=>{
const zoomed=dialog.classList.toggle('is-zoomed');
toggle.setAttribute('aria-pressed',String(zoomed));
toggle.textContent=zoomed?toggle.dataset.out:toggle.dataset.in;
});
}
});
}
  } catch(e) { console.error(e); }
})();

})();
